import { useEffect, useState } from "react";
import destIcon from "@icons/destination.svg";
import startIcon from "@icons/start.svg";
import { GoogleMap, Marker } from "@react-google-maps/api";
import useConfig from "@lib/use_config";

function RouteMap({
  startPoint,
  endPoint,
  width,
  height,
}: {
  startPoint: be.LatLng;
  endPoint: be.LatLng;
  width: string;
  height: string;
}): JSX.Element | null {
  const [map, setMap] = useState<google.maps.Map | null>();
  const [dirRenderer, setDirRenderer] = useState<google.maps.DirectionsRenderer>();
  const { loading, data, error } = useConfig(["defaultSearchCenter { lat lng }"]);

  // Set direction renderer
  useEffect(() => {
    if (!map || dirRenderer) return;
    setDirRenderer(new google.maps.DirectionsRenderer({ map, suppressMarkers: true }));
  }, [dirRenderer, map]);

  // Set directions and bounds.
  useEffect(() => {
    if (!map || !dirRenderer) return;

    const dirService = new google.maps.DirectionsService(),
      request = {
        origin: startPoint,
        destination: endPoint,
        travelMode: google.maps.TravelMode.DRIVING,
      };

    dirService.route(request, function (response, status) {
      if (status == google.maps.DirectionsStatus.OK) {
        dirRenderer.setDirections(response);
        const dirs = dirRenderer.getDirections();
        if (!dirs) return;
        const bounds = dirs.routes[0].bounds;
        map.fitBounds(bounds);
        map.setCenter(bounds.getCenter());
      } else {
        console.warn(status);
      }
    });
  }, [dirRenderer, map, startPoint, endPoint, width, height]);

  if (error) console.error(error);

  return error || loading ? null : (
    <GoogleMap
      mapContainerStyle={{ width, height }}
      center={startPoint || data.config.defaultSearchCenter}
      onLoad={setMap}
      options={{ mapTypeControl: false, streetViewControl: false, fullscreenControl: false }}
    >
      <Marker
        position={endPoint}
        icon={{ scaledSize: new google.maps.Size(35, 35), url: destIcon.src }}
      />
      <Marker
        position={startPoint}
        icon={{ scaledSize: new google.maps.Size(35, 35), url: startIcon.src }}
      />
    </GoogleMap>
  );
}

export default RouteMap;
